import { inject } from '@angular/core';
import { Route, UrlSegment, CanMatchFn } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { UserRole } from '../models/role.enum';

/**
 * Role Match Guard
 * Used with 'canMatch' to filter routes based on user role.
 * Does NOT redirect if failed - simply returns false, allowing Router to try next route.
 */
export function createRoleMatchGuard(allowedRoles: UserRole[]): CanMatchFn {
  return (route: Route, segments: UrlSegment[]) => {
    const authService = inject(AuthService);
    
    // Check if user has required role
    const hasRole = authService.hasAnyRole(allowedRoles);
    
    // Return true if matches (route will be used), false if not (router skips to next)
    return hasRole;
  };
}
